var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLockedComputer = function SvgLockedComputer(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 161,
    viewBox: "0 0 160 161",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M160 80.5c0 44.46-35.818 80.5-80 80.5S0 124.96 0 80.5 35.818 0 80 0s80 36.04 80 80.5",
    id: "a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#EEF2F6",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#171C94",
    d: "M70.244 113.466h19.633V97.14H70.244z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#171C94",
    strokeWidth: 0.534,
    d: "M70.244 113.466h19.633V97.14H70.244z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211551",
    d: "M30.26 94.657h100.158V41.511H30.26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.29 103.083H35.386c-2.832 0-5.128-2.31-5.128-5.16v-6.726h100.158v6.726c0 2.85-2.296 5.16-5.128 5.16",
    fill: "#211551"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE2737",
    d: "M32.493 92.698h95.691V44.904H32.493z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211551",
    d: "M58.36 117.273h43.4v-4.24h-43.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.962 43.195a.819.819 0 01-.816.821.818.818 0 01-.815-.82c0-.455.365-.822.815-.822.45 0 .816.367.816.821",
    fill: "#C8D8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.007 51.89L59.262 82.819c-.952 1.657.238 3.727 2.139 3.727h35.492c1.9 0 3.09-2.07 2.14-3.727l-17.747-30.93c-.952-1.655-3.328-1.655-4.279 0",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.146 76.983c1.135 0 1.968.836 1.968 1.922v.28c0 1.087-.833 1.923-1.968 1.923-1.108 0-1.966-.836-1.966-1.924v-.28c0-1.085.858-1.921 1.966-1.921zm-1.966-14.41c-.056-.67.332-1.2.97-1.2h1.992c.638 0 1.054.53.997 1.2l-.968 11.37c-.056.616-.47 1.005-1.025 1.005-.553 0-.941-.39-.996-1.004l-.97-11.371z",
    fill: "#EE2737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.98 73.101c-.984-.668-4.444 1.372-7.262 5.12-.167-5.114-2.052-9.149-3.327-9.149-1.274 0-3.16 4.04-3.328 9.156-2.817-3.753-6.28-5.795-7.265-5.127-1.062.72-.303 5.327 2.607 9.668 2.91 4.344 6.458 7.057 7.93 6.06.003-.003.004-.005.008-.007.016 0 .032.006.048.006s.03-.006.046-.006l.008.006c1.468.998 5.02-1.715 7.93-6.059 2.908-4.341 3.669-8.947 2.605-9.668",
    fill: "#171C94"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F58220",
    d: "M-9.944 95.288h32.67V85.64h-32.67zM16.34 117.447H-3.556l-3.618-22.158h27.132z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E35205",
    d: "M-6.588 98.898H19.37l.587-3.609h-27.13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.462 73.101c-.984-.668-4.444 1.372-7.262 5.12-.167-5.114-2.052-9.149-3.327-9.149-1.274 0-3.16 4.04-3.328 9.156-2.817-3.753-6.28-5.795-7.265-5.127-1.062.72-.303 5.327 2.607 9.668 2.909 4.344 6.46 7.057 7.93 6.06.003-.003.004-.005.008-.007.016 0 .031.006.048.006.016 0 .03-.006.046-.006l.008.006c1.468.998 5.02-1.715 7.93-6.059 2.907-4.341 3.669-8.947 2.605-9.668",
    fill: "#171C94"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F58220",
    d: "M137.539 95.288h32.67V85.64h-32.67zM163.823 117.447h-19.9l-3.615-22.158h27.132z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E35205",
    d: "M140.895 98.898h25.957l.586-3.609h-27.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#75787B",
    d: "M-4.94 163.431h168.26v-46.158H-4.94z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLockedComputer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/locked-computer.7783f295a51b63f1ddc8246f71e6f39a.svg";